module.exports = "#NotificationsTable {\n  color: #000;\n}\n#NotificationsTable a {\n  color: #000;\n}\n#NotificationsTable .notification-read {\n  color: #999;\n}\n#NotificationsTable .notification-read a {\n  color: #999;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/notifications/notifications.component.less
// module id = ./src/app/shared/layout/notifications/notifications.component.less
// module chunks = main